/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerManualRunAodRulesMutationRequest, TriggerManualRunAodRulesMutationResponse, TriggerManualRunAodRulesPathParams } from "../models/TriggerManualRunAodRules";

export function getTriggerManualRunAodRulesUrl(id: TriggerManualRunAodRulesPathParams["id"]) {
  const res = { method: 'POST', url: `/aod-rules/${id}/manual-run` as const }
  return res
}

/**
 * @description Triggers a manual AOD run for a specific AOD rule
 * @summary Trigger a manual AOD run for an AOD rule
 * {@link /aod-rules/:id/manual-run}
 */
export async function triggerManualRunAodRules(id: TriggerManualRunAodRulesPathParams["id"], data: TriggerManualRunAodRulesMutationRequest, config: Partial<RequestConfig<TriggerManualRunAodRulesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<TriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<Error>, TriggerManualRunAodRulesMutationRequest>({ method : "POST", url : getTriggerManualRunAodRulesUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}